import ImageUremont from "@shared/ui/ImageStaticAds/assets/uremont-273х480.png";

export const UREMONT_BANNER = {
    SRC: ImageUremont,
    ALT: "Автознаток или новичок? Тест на тип автовладельца",
    TITLE: " Автознаток или новичок? Узнайте, к какому типу владельцев  относитесь вы",
    LINK: "https://quiz.uremont.com/likvi/?utm_source=main_page"
};

export const STATIC_BANNER_POSITION = 0;